import * as Configuration from '../../../app.constants.js';

CustomFieldController.$inject = ['$scope', '$sce', 'TopToolbarFactory', '$stateParams', 'UserFactory'];

export function CustomFieldController($scope, $sce, TopToolbarFactory, $stateParams, UserFactory) {
  init();

  function init() {
    const loggedUser = UserFactory.getLoggedUser();
    TopToolbarFactory.setTitleTranslation('parameters/minicrm/title', $scope);

    const iFrameUrl = `${Configuration.constants.customFieldBaseUrl}/routes/auth/${$stateParams.requestedPage}`;

    const params = {
      lang: loggedUser.lang,
      companyid: loggedUser.companies[0].id,
      'user-timezone': loggedUser.timezone,
    };

    const iFrameUrlParams = Object.keys(params)
      .map(value => `${value}=${encodeURIComponent(params[value])}`)
      .join('&');

    $scope.iFrameUrl = $sce.trustAsResourceUrl(`${iFrameUrl}?${iFrameUrlParams}`);
  }
}
